"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RendererRegistry = void 0;
const RendererFactoryRegistry_1 = __importDefault(require("../RendererFactoryRegistry"));
exports.RendererRegistry = {
    _renderers: new Map(),
    get: (viewField, colIdx, pdf = false) => {
        if (!exports.RendererRegistry._renderers.has(viewField)) {
            const renderer = RendererFactoryRegistry_1.default[viewField.fieldType](viewField, colIdx, pdf);
            exports.RendererRegistry._renderers.set(viewField, renderer);
        }
        return exports.RendererRegistry._renderers.get(viewField);
    },
};
exports.default = exports.RendererRegistry;
